const javascriptQuestions = [
  {
    question: "What is a closure?",
    options: [
      "An inner function",
      "A global variable",
      "A block scope",
      "An API",
      "A type of object",
      "None of these",
    ],
    correctOption: 0,
  },
  {
    question: "Which type of scope is supported in JavaScript?",
    options: [
      "Global",
      "Local",
      "Function",
      "All of the above",
      "Block",
      "Module",
    ],
    correctOption: 3,
  },
  {
    question: "What is the use of the 'this' keyword in JavaScript?",
    options: [
      "It refers to the current object",
      "It refers to a global variable",
      "It creates a function",
      "It creates an array",
      "It accesses private variables",
      "None of these",
    ],
    correctOption: 0,
  },
  {
    question: "What is the output of 'typeof NaN' in JavaScript?",
    options: ["NaN", "number", "undefined", "object", "null", "string"],
    correctOption: 1,
  },
  {
    question: "What is the difference between '==' and '===' in JavaScript?",
    options: [
      "'==' compares value only, '===' compares value and type",
      "'==' compares type only, '===' compares value only",
      "'==' compares memory address, '===' compares value",
      "'==' compares values after converting types, '===' compares without conversion",
      "'==' does strict comparison, '===' does loose comparison",
      "They are the same",
    ],
    correctOption: 0,
  },
  {
    question:
      "Which method is used to convert an object into a JSON string in JavaScript?",
    options: [
      "JSON.stringify()",
      "JSON.parse()",
      "Object.toString()",
      "Object.toJSON()",
      "Object.parse()",
      "None of these",
    ],
    correctOption: 0,
  },
  {
    question: "How can you add a new element to the end of an array?",
    options: [
      "array.push()",
      "array.pop()",
      "array.add()",
      "array.insert()",
      "array.append()",
      "array.unshift()",
    ],
    correctOption: 0,
  },
  {
    question:
      "Which of the following is NOT a primitive data type in JavaScript?",
    options: ["String", "Boolean", "Undefined", "Number", "Object", "Symbol"],
    correctOption: 4,
  },
  {
    question: "What does 'use strict' do in JavaScript?",
    options: [
      "Enforces strict parsing and error handling",
      "Prevents the use of global variables",
      "Enables support for ES6 features",
      "Allows for backward compatibility",
      "Strictly defines variable types",
      "None of these",
    ],
    correctOption: 1,
  },
  {
    question: "Which of the following is a feature of arrow functions?",
    options: [
      "Implicit return",
      "No need for 'this' keyword",
      "Can be used as a constructor",
      "They automatically bind 'this' to the outer function",
      "Both 1 and 4",
      "Both 1 and 2",
    ],
    correctOption: 5,
  },
  {
    question: "What is the purpose of the 'map' method in arrays?",
    options: [
      "To create a new array by transforming each element",
      "To find the index of an element in the array",
      "To remove elements from the array",
      "To filter out unwanted elements",
      "To concatenate two arrays",
      "To modify an element in place",
    ],
    correctOption: 0,
  },
];

export default javascriptQuestions;
